import type { WorkRow } from '../work-row'

type Props = { row: WorkRow }

/** A value as one line: strings bare, everything else as JSON. */
const cell = (value: unknown): string => {
    if (value === null || value === undefined) return '—'
    if (typeof value === 'string') return value
    return JSON.stringify(value)
}

/**
 * The settings body for any kind the frontend does not know: every stored
 * param, as key and value. Nothing is hidden, so a new kind is readable on
 * the page the day it lands, before anyone writes it a body of its own.
 */
function GenericParamsDetails({ row }: Props) {
    const entries = Object.entries(row.params ?? {})
    if (entries.length === 0) {
        return <p className="text-sm text-ink-500">This row has no settings.</p>
    }
    return (
        <table className="w-full text-sm">
            <tbody className="divide-y divide-ink-100">
                {entries.map(([key, value]) => (
                    <tr key={key}>
                        <th
                            scope="row"
                            className="py-1 pr-3 text-left align-top font-mono text-xs font-normal text-ink-500 whitespace-nowrap"
                        >
                            {key}
                        </th>
                        <td className="py-1 align-top text-ink-900 break-all">{cell(value)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default GenericParamsDetails
